module.exports = __webpack_public_path__ + "static/media/Dilshan.eab8b531.jpg";